var _rect, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFashionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_78",
    "data-name": "\\uADF8\\uB8F9 78",
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.045,
    height: 179.307,
    viewBox: "0 0 180.045 179.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_19",
    "data-name": "\\uC0AC\\uAC01\\uD615 19",
    width: 89.653,
    height: 89.653,
    transform: "translate(44.827 44.827)",
    fill: "#db3633"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20",
    "data-name": "\\uADF8\\uB8F9 20",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_6",
    "data-name": "\\uD0C0\\uC6D0 6",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.827,
    cy: 44.827,
    r: 44.827,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.827,
    cy: 44.827,
    r: 44.327,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_26",
    "data-name": "\\uC120 26",
    y2: 89.653,
    transform: "translate(44.827)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21",
    "data-name": "\\uADF8\\uB8F9 21",
    transform: "translate(90.392 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_7",
    "data-name": "\\uD0C0\\uC6D0 7",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.827,
    cy: 44.827,
    r: 44.827,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.827,
    cy: 44.827,
    r: 44.327,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_27",
    "data-name": "\\uC120 27",
    y2: 89.653,
    transform: "translate(44.827)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22",
    "data-name": "\\uADF8\\uB8F9 22",
    transform: "translate(0 89.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_8",
    "data-name": "\\uD0C0\\uC6D0 8",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.827,
    cy: 44.827,
    r: 44.827,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.827,
    cy: 44.827,
    r: 44.327,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_28",
    "data-name": "\\uC120 28",
    y2: 89.653,
    transform: "translate(44.827)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_23",
    "data-name": "\\uADF8\\uB8F9 23",
    transform: "translate(90.392 89.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_9",
    "data-name": "\\uD0C0\\uC6D0 9",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44.827,
    cy: 44.827,
    r: 44.827,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.827,
    cy: 44.827,
    r: 44.327,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_29",
    "data-name": "\\uC120 29",
    y2: 89.653,
    transform: "translate(44.827)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFashionLogo);
export default __webpack_public_path__ + "static/media/fashion_logo.96f8f1bc662401636fd41be8cb8dc9a2.svg";
export { ForwardRef as ReactComponent };